const appApi = 'https://x7ywly1o1m.execute-api.us-east-1.amazonaws.com/dev'
//const appApi = 'http://localhost:3000'
export const userCreateApi = `${appApi}/user/create`
export const userUpdateApi = `${appApi}/user/update`
export const userLoadApi = `${appApi}/user-public/?usertoken=`
export const userRelatedProfilesApi = `${appApi}/user/related-profiles`
export const userExistsApi = `${appApi}/user-exists`
export const clientProfileCreateApi = `${appApi}/clients/profile/create`
export const clientProfileUpdateApi = `${appApi}/clients/profile/update`
export const clientProfileReadApi = `${appApi}/clients/profile`
export const clientInviteCreateApi = `${appApi}/client/member-invite/create`
export const clientMembersApi = `${appApi}/client/member/list`
export const clientInviteResendApi = `${appApi}/client/member-invite/resend`
export const clientInviteReadApi = `${appApi}/client/member-invite`
export const clientInviteCheckApi = `${appApi}/client/member-invite/check`
export const clientMemberAddApi = `${appApi}/client/member/add`
export const clientListLoadApi = `${appApi}/clients/search`
export const clientStoreCheckApi = `${appApi}/client/store-check`
export const clientStoreListApi = `${appApi}/client/store-list`

export const trackingLinkCreateApi = `${appApi}/tracking-link/create`
export const trackingLinkReadListApi = `${appApi}/tracking-link/list`
export const trackingLinkUpdateApi = `${appApi}/tracking-link/update`
export const trackingLinkAnalyticsApi = `${appApi}/tracking-link/analytics`

export const trackingLinkTemplateCreateApi = `${appApi}/tracking-link/template/create`
export const trackingLinkTemplateListApi = `${appApi}/tracking-link/template/list`
export const trackingLinkTemplateUpdateApi = `${appApi}/tracking-link/template/update`


export const leadAdsApi = `https://wc0fq3w00b.execute-api.us-east-1.amazonaws.com/production/search/brand-ads/?igid=`
export const adRefreshApi = `https://wc0fq3w00b.execute-api.us-east-1.amazonaws.com/production/ads/reload-source/?source=`
export const igProfileListApi = `https://q34t9umgk2.execute-api.us-east-1.amazonaws.com/prod/igprofile/list/?usertoken=`
export const igProfileCreateApi = `https://q34t9umgk2.execute-api.us-east-1.amazonaws.com/prod/igprofile/create`
export const igProfileArchiveApi = `https://q34t9umgk2.execute-api.us-east-1.amazonaws.com/prod/igprofile/archive`
export const igProfileEngagementCandidateListApi = `https://q34t9umgk2.execute-api.us-east-1.amazonaws.com/prod/candidates`
export const igProfileEngagementCandidateStatusApi = `https://q34t9umgk2.execute-api.us-east-1.amazonaws.com/prod/candidate/status`
export const igProfileReadApi = `http://localhost:3000/prod/igprofile/`
export const hashtagSourceListApi = `https://q34t9umgk2.execute-api.us-east-1.amazonaws.com/prod/hashtag/list`
export const hashtagSourceAddApi = `https://q34t9umgk2.execute-api.us-east-1.amazonaws.com/prod/hashtag/add`
export const hashtagSourceArchiveApi = `https://q34t9umgk2.execute-api.us-east-1.amazonaws.com/prod/hashtag/archive`


// TAPSPREE DATA ENDPOINTS
export const igCheckApi = 'https://wc0fq3w00b.execute-api.us-east-1.amazonaws.com/production/user/instagram-check'


// INFLUENCER MANAGEMENT ENDPOINTS 
const influencerApi = 'https://3aameczti4.execute-api.us-east-1.amazonaws.com/prod'
//const influencerApi = 'http://localhost:3000'

export const influencerCampaignCreateApi = `${influencerApi }/influencer/campaign/create`
export const influencerCampaignReadApi = `${influencerApi }/influencer/campaign`
export const influencerCampaignSearchApi = `${influencerApi }/influencer/campaign/search`
export const influencerCampaignClientReadApi = `${influencerApi }/influencer/campaign/client`

export const influencerContentCreateApi = `${influencerApi }/influencer/campaign/content/create`
export const influencerContentUpdateApi = `${influencerApi }/influencer/campaign/content/update`
export const influencerContentGetDetailApi = `${influencerApi }/influencer/campaign/content`
export const influencerContentGetListApi = `${influencerApi }/influencer/campaign/content/list`

// Influencer Earnings
const influencerEarningsApi = 'https://wdxjrm2dr8.execute-api.us-east-1.amazonaws.com/prod'

export const influencerEarningsByUser = `${influencerEarningsApi}/earnings/analytics/user`

// Campaign content note
export const influencerCreateContentNoteApi = `${influencerApi }/influencer/content-note/create`
export const influencerUpdateContentNoteApi = `${influencerApi }/influencer/content-note/update`
export const influencerGetAllContentNoteApi = `${influencerApi }/influencer/content-note/list`

export const influencerCollabPostAddApi = `${influencerApi }/influencer/campaign/post/add`
export const influencerCollabPostCheckApi = `${influencerApi }/influencer/campaign/post/check`
export const influencerCollabPostSearchApi = `${influencerApi }/influencer/campaign/post/search`
export const influencerCampaignAnalyticsReadApi = `${influencerApi }/influencer/campaign/analytics`
export const influencerCampaignTrackingCreateApi = `${influencerApi }/influencer/campaign/tracking/create`
export const influencerCampaignTrackingUpdateApi = `${influencerApi }/influencer/campaign/tracking/update`
export const influencerCampaignTrackingListApi = `${influencerApi }/influencer/campaign/tracking/list`
export const influencerCampaignCandidateListApi = `${influencerApi }/influencer/campaign/candidate-list`
export const influencerCollabPostArchiveApi = `${influencerApi }/influencer/campaign/post/archive`

//const influencerCandidateApi = 'http://localhost:3000'
const influencerCandidateApi = 'https://uhvmca0oa5.execute-api.us-east-1.amazonaws.com/prod'
export const influencerCampaignCandidateAddApi = `${influencerCandidateApi }/influencer/campaign/candidate-add`
export const influencerCandidateReadApi = `${influencerCandidateApi }/influencer`
export const influencerCandidatePaymentDetailsApi = `${influencerCandidateApi}/influencer/candidate/payment-details`
export const influencerCampaignCandidateReadApi = `${influencerCandidateApi }/influencer/campaign/candidate`
export const influencerCandidateEventsAddApi = `${influencerCandidateApi }/influencer/campaign/candidate-events-add`
export const influencerCandidateUpdateStatusBatchApi = `${influencerCandidateApi }/influencer/campaign/candidate-update-status/batch`
export const influencerCandidateUpdateStatusApi = `${influencerCandidateApi}/influencer/campaign/candidate-update-status`
export const influencerCandidateNoteCreateApi = `${influencerCandidateApi }/influencer/campaign/note-create`
export const influencerCandidateNoteUpdateApi = `${influencerCandidateApi }/influencer/campaign/note-update`
export const influencerCandidateNoteArchiveApi = `${influencerCandidateApi}/influencer/campaign/note-archive`
export const influencerCandidateStatusApi = `${influencerCandidateApi }/influencer/status`
export const influencerCandidateJoinApi = `${influencerCandidateApi }/influencer/join`
export const influencerCollaborationListApi = `${influencerCandidateApi }/influencer/collaboration/list`
export const influencerCollaborationDetailApi = `${influencerCandidateApi }/influencer/collaboration`

export const influencerTagSearchApi = `${influencerCandidateApi }/influencer/tags/search`
export const influencerTagAddApi = `${influencerCandidateApi }/influencer/tags/add`
export const influencerTagUpdateApi = `${influencerCandidateApi }/influencer/tags/update`
export const influencerUpdateApi = `${influencerCandidateApi }/influencer/update`
export const influencerEventUpdateApi = `${influencerCandidateApi }/influencer/event/update`


const instagramApiEndpoint = 'https://ajar0ca0zi.execute-api.us-east-1.amazonaws.com/dev'
//const instagramApiEndpoint = 'http://localhost:4000'
export const influencerCandidateSearchRelatedApi = `${instagramApiEndpoint}/instagram/search/related-profiles`
export const influencerCandidateSearchLocationApi = `${instagramApiEndpoint}/instagram/search/location-profiles`
export const influencerCandidateSearchHashtagApi = `${instagramApiEndpoint}/instagram/search/hashtag-profiles`
export const influencerCandidateSearchKeywordApi = `${instagramApiEndpoint}/instagram/search/keyword-profiles`
export const influencerCandidateSearchLocationLoadApi = `${instagramApiEndpoint}/instagram/search/location-profiles-reload`
export const influencerCandidateSearchLRelatedLoadApi = `${instagramApiEndpoint}/instagram/search/related-profiles-reload`
export const influencerCandidateSearchLHashtagLoadApi = `${instagramApiEndpoint}/instagram/search/hashtag-profiles-reload`
export const influencerCandidateSearchLKeywordLoadApi = `${instagramApiEndpoint}/instagram/search/keyword-profiles-reload`
export const instagramPostCacheApi = `${instagramApiEndpoint}/instagram/post/cache`
export const instagramProfileCacheApi = `${instagramApiEndpoint}/instagram/profile/cache`


export const instagramPostApi = `${instagramApiEndpoint}/instagram/post/list`
export const instagramProfileAnalyticsApi = `${instagramApiEndpoint}/instagram/profile/analytics`
export const instagramPostAnalyticsApi = `${instagramApiEndpoint}/instagram/post/analytics`
export const instagramPostDetailsApi = `${instagramApiEndpoint}/instagram/post/details`
export const loadInstagramProfile = `${instagramApiEndpoint}/instagram/profile`
export const loadInstagramProfilePublic = `${instagramApiEndpoint}/instagram/profile/public`
export const fbGraphCreateProfile = `${instagramApiEndpoint}/fb-graph/profile/create`
export const fbGraphProfileDelete = `${instagramApiEndpoint}/fb-graph/profile/delete`
export const fbGraphInstagramCheck = `${instagramApiEndpoint}/fb-graph/instagram/check`
export const fbGraphInstagramInsights = `${instagramApiEndpoint}/fb-graph/instagram/insights`
export const fbGraphMentionPosts = `${instagramApiEndpoint}/fb-graph/instagram/mentions`

const instagramSearchEndpoint = `https://2n91ds5cb8.execute-api.us-east-1.amazonaws.com/prod`
//const instagramSearchEndpoint = 'http://localhost:5000'
export const instagramHashtagSearchApi = `${instagramSearchEndpoint}/search/hashtags`
export const instagramContentSearchApi = `${instagramSearchEndpoint}/search/hashtag/content`

const adSearchEndpoint = `https://mhqhiyou95.execute-api.us-east-1.amazonaws.com/prod`
//const adSearchEndpoint = 'http://localhost:9000'
/*export const categoryLoadApi = `${appApi}/leads/categories/?usertoken=`
export const leadsSearchApi = `${appApi}/leads/search/?usertoken=`
export const leadLoadApi = `${appApi}/leads/?usertoken=`*/
export const adSearchApi = `${adSearchEndpoint}/search`
export const adCacheApi = `${adSearchEndpoint}/ad/cache`
export const adDetailApi = `${adSearchEndpoint}/ad/detail`

// SHOPIFY API 
const shopifyEndpoint = `https://kfnxitc4c8.execute-api.us-east-1.amazonaws.com/production`
//const shopifyEndpoint = `http://localhost:5000`

export const discountCodeReadApi = `${shopifyEndpoint}/discount`
export const discountCodeCreateApi = `${shopifyEndpoint}/discount/create`
export const influencerDiscountReadApi = `${shopifyEndpoint}/discount/influencer`
export const discountCodeSearchApi = `${shopifyEndpoint}/discount/search`
export const discountCodeSearchDetailedApi = `${shopifyEndpoint}/discount/search-detail`
export const discountCodeArchiveApi = `${shopifyEndpoint}/discount/archive`
export const shopifyOrderAnalyticsApi = `${shopifyEndpoint}/order/analytics`
export const shopifyStoreArchiveApi = `${shopifyEndpoint}/shop/archive`
export const shopifyStoreCreateApi = `${shopifyEndpoint}/shop/create`

const earningsEndpoint = ` https://wdxjrm2dr8.execute-api.us-east-1.amazonaws.com/prod`
//const earningsEndpoint = `http://localhost:4000`
export const paymentActionReadApi = `${earningsEndpoint}/payment/actions`
export const paymentActionCreateApi = `${earningsEndpoint}/payment/actions/create`
export const paymentActionUpdateApi = `${earningsEndpoint}/payment/actions/update`
export const paymentActionListApi = `${earningsEndpoint}/payment/actions/influencer`

export const paymentDetailReadApi = `${earningsEndpoint}/payment/details`
export const paymentDetailCreateApi = `${earningsEndpoint}/payment/details/create`
export const paymentDetailUpdateApi = `${earningsEndpoint}/payment/details/update`
export const paymentDetailListApi = `${earningsEndpoint}/payment/details/influencer`

export const commissionDetailReadApi = `${earningsEndpoint}/commission/details`
export const commissionDetailCreateApi = `${earningsEndpoint}/commission/details/create`
export const commissionDetailUpdateApi = `${earningsEndpoint}/commission/details/update`
export const commissionDetailListApi = `${earningsEndpoint}/commission/details/influencer`